// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"PageTitleSection_pageTitle__pzh0m"};